// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "button-zlQwO";
var _3 = "container-1EgCU";
export { _1 as "__esModule", _2 as "button", _3 as "container" }
export default { "__esModule": _1, "button": _2, "container": _3 }
